export default __webpack_public_path__ + "static/media/ipimg.2ea95c37.png";